export {}
declare const posthog: any;
import { getCreditUnionGroups } from './posthog-group'
document.querySelector('[submit-loan-button]')?.addEventListener('click', async event => {
    event.preventDefault();

    const target = event.target as HTMLFormElement
    const targetForm = target.closest('form')
    const spinner = document.getElementById('loading-spinner')

    if (targetForm) {
        spinner?.classList.remove('hidden')

        const formData = new FormData(targetForm);
        const errorDiv = document.querySelector('.error-text')

        let response = await fetch('?', { method: 'POST', body: formData })
        let data = await response.json()
        console.log(data)

        if (data.success) {
            if (typeof posthog !== 'undefined') {
                posthog.capture('credit_app_submitted', {
                    credit_app_deal_jacket_id: data.creditAppDealJacketId ?? undefined,
                    $groups: getCreditUnionGroups(),
                });

                const emailEl = document.querySelector<HTMLInputElement>('input[name="Email"], input[type="email"]');
                const email = emailEl?.value?.trim();
                if (email && email.length > 0) {
                    posthog.identify(email, { creditAppSubmitted: true });
                }
            }

            window.location.href = `/loan/credit-app-success?CreditAppDealJacketId=${data.creditAppDealJacketId}`
        }
        else {
            spinner?.classList.add('hidden')

            if (errorDiv)
                errorDiv.innerHTML = "An error occurred: " + data.error
            else
                alert("An error occurred: " + data.error)

            // Scroll to top
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
})
